module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "preface-title"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-illustrations"
    }
  }, [_vm._v("ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _vm._v("Unless otherwise indicated, all photographs are from private collections.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilfred Thesiger’s grandfather, General Frederic Augustus Thesiger, 2nd Baron Chelmsford (1827–1905), who commanded the British\n         force during the Zulu War in South Africa in 1879.\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain The Hon Wilfred Gilbert Thesiger DSO, c. 1902.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger’s mother, about 1919.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The thatched "), _c('em', [_vm._v("tukul")]), _vm._v(" in the British Legation compound at Addis Ababa, where Wilfred Patrick Thesiger was born on 3 June 1910. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Billy, as the baby Wilfred was known, with Susannah, his Indian nursemaid, on the Legation lawn, Addis Ababa in 1911.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Susannah’s successor Minna (Mary Buckle) in camp during a trek in Abyssinia, about 1915.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilfred Gilbert Thesiger and Ras Tafari on the steps of the British Legation at Addis Ababa.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part of the victory parade on Jan Meda, Addis Ababa, following the Battle of Sagale in 1916. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The four Thesiger brothers in Bombay, 1918.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger’s uncle Frederic John Napier Thesiger, first Viscount Chelmsford (1868–1933), Viceroy of India 1916–21.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The widowed Kathleen Thesiger with her four sons.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pierre, a Breton fisherman, and his thirteen-year-old "), _c('em', [_vm._v("mousee")]), _vm._v(" at Sable d’Or, Britanny, in 1929.\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger, aged twenty-two, at the Villa Cipressi, his stepfather Reginald Astley’s house on Lake Como, in 1932.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Val ffrench Blake, a friend of Thesiger’s at Eton.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Milebrook in the Teme Valley, Radnorshire, which Kathleen leased from 1921 to 1942.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "id": "pagex"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter010#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger photographed at the time he left Eton, in 1928.\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One of a series of boxing photographs taken in the early 1930s.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A unique photograph of Thesiger boxing for Oxford University.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger’s caravan near the Awash Station in December 1933, at the start of his 1933-34 expedition to trace the Awash river\n         to its mysterious end in the unexplored Sultanate of Aussa, Abyssinia. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Omar Ibrahim, Thesiger’s headman, with the members of the Awash expedition.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crossing the Awash at Bilen. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A party of Danakil warriors near the Mullu waterholes midway between Afdam and and Bahdu, Abyssinia, on 10 February 1934.\n         "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guy Moore at Wasi Tini, Sudan, 1938.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Idris Daud of the Kobe-Zaghawa tribe, who joined Thesiger at Kutum, Northern Darfur, in 1935.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Idris and Zaghawa tribesmen with a lioness Thesiger had shot. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bab Segma, Fez, November 1937.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kilwal, Upper Nile, Sudan. Nier tribesman watch as a hippo is harpooned. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tibesti, August–November 1938. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger’s bodyguard, Abyssinia 1941. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger and Haile Selassie at Khartoum in 1940. "), _c('em', [_vm._v("(The War Office.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonel Dan Sandford presenting a silver salver to Haile Selassie.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The column of Thesiger’s capture Italian troops extended for a mile. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faris Shahin, who served with Thesider in the Druze Legion.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonel David Stirling wearing the badge of the SAS. "), _c('em', [_vm._v("(Courtesy of the Imperial War Museum)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A patrol jeep, similar to the vehicle Thesiger used on SAS raids in North Africa. "), _c('em', [_vm._v("(Courtesy of the Imperial War Museum)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crossing the Rub’ al Khali, the Empty Quarter, the great sand desert of southern Arabia. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salim bin Kabina of the Rashid, brining fodder for the camels from the lee side of a dune. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter015#fig38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salim bin Ghabaisha of the Rashid, who accompanied Thesiger on his journeys in southern Arabia. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bin Kabina and bin Ghabaisha in Oman, 1950. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muhammad al Auf, Thesiger’s Rashid Guide, in 1947. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger photographed by bin Kabina in the Empty Quarter. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger in Arah dress, 1950 "), _c('em', [_vm._v("(Ronald Codrai)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nasser Hussain, Thesigers companion and guide in the Iraqi Kurdistan in 1950-51. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A narrow waterway between tall reedbeds in the Iraqi marshes. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bani Lam tribesmen with a wild boar Thesiger had ridden down and shot from the saddle in tamarisk scrub near the Tigris in\n         June 1958. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger’s "), _c('em', [_vm._v("tarada. (Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#fig47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taradas and other craft at a market in the Iraqi marshers. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interior of a mudhif, or guest house, nearing completion. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suaid herdboy. This image was used for the frontispiece for the first edition of "), _c('em', [_vm._v("The Marsh Arabs,")]), _vm._v(" 15 November 1961. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kandari nomads coming down from Lake Shiva to the plains, 1965. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger in Copenhagen while he was writing the "), _c('em', [_vm._v("The Marsh Arabs")]), _vm._v(", 15 November 1961. (Helge Ralov)\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger and Kathleen, about 1961.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jan Verney Kathleen and Thesiger on holiday in Portugal in June-July 1961.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger’s portrait, painted in 1965 by Derek Hill. "), _c('em', [_vm._v("(Derek Hill)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outside the Travellers Club, Pall Mall, in 1973. "), _c('em', [_vm._v("(Anglia Television)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger and David Niven at the Royal Geographical Society. "), _c('em', [_vm._v("(Anglia Television)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aboard the "), _c('em', [_vm._v("Fiona,")]), _vm._v(" the 42-foot ketch on which Thesiger and Gavin Young sailed for five months round the Indonesian islands in 1977 in search\n         of Joseph Conrad’s eastern world. "), _c('em', [_vm._v("(Gavin Young)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter020#fig58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger and Gavin Young at Thesiger’s flat in Chelsea, 1977.\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger and Lokuyie, a Samburu "), _c('em', [_vm._v("moran,")]), _vm._v(" in northern Kenya. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Frank Steele on the Uaso Nyiro river, Kenya, in 1970.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Newbould with a pelican on the shores of Lake Natron.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kisau, Thesiger’s devoted companion, who died in 1974.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lawi Leboyare. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laputa Lekakwar, in whose house Thesiger lived during his last years at Maralal.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ewoi Ekai, known as ‘Kibiriti,’ in his garden near Maralal.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger and Erope on safari. "), _c('em', [_vm._v("(Pitt Rivers Museum, University of Oxford)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking out from ‘The Viewpoiint’ on the edge of the escarpment at Malossa, near Maralal.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thesiger stroking the nose of ‘Africano,’ greatest of the bulls on Robert Vavra’s farm near Seville, in July 1996. "), _c('em', [_vm._v("(Robert Vavra)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilfred Thesiger leaving for Buckingham Palace with Alexander Maitland, on 2 November 1995. "), _c('em', [_vm._v("(Julian Barrow)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a8c54c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/illustrations.vue
// module id = 72
// module chunks = 0